import { render, staticRenderFns } from "./ZeitraeumeReiter.vue?vue&type=template&id=8a956b3a&scoped=true"
import script from "./ZeitraeumeReiter.vue?vue&type=script&lang=js"
export * from "./ZeitraeumeReiter.vue?vue&type=script&lang=js"
import style0 from "./ZeitraeumeReiter.vue?vue&type=style&index=0&id=8a956b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a956b3a",
  null
  
)

export default component.exports